
 



    <div class="main-center" style="margin-top: 30px; margin-bottom: 20px;">
        <img src="../../../../assets/images/splash_logo.svg" width="200px">
    </div>
    <div class="main-center" style="margin-top:40px">

        <div>
            <p class="head" style="font-size: 35px; text-align: center;">Download <span style="font-weight: bold;">Wetap</span> App</p>
           
                
                    <p style="color: grey; font-size: 16px; text-align: center;">Available on both:</p>
                <div class="main-center">
                    <a href="https://play.google.com/store/apps/details?id=com.zimblecode.wetap" target="_blank"><img src="../../../../assets/images/play-store.svg" width="120px"></a>
                    <a href="https://apps.apple.com/us/app/get-wetap/id1660750697" target="_blank"><img src="../../../../assets/images/App-store.svg" width="120px"></a>
                </div>  
        
            <div>
                <p class="head" style="font-weight: bold; font-size: 35px; margin-top: 50px; text-align: center;">How to Tap</p>
                <ul style="font-size: 25px;">
                    <li style="margin-top: 10px">
                        <div class="row mt-3 mb-3" style="width:70vw; align-items: center;">
                            <div class="col-md-6">
                                    <p>Scan the QR code with your phone.</p> 
                            </div>
                            <div class="col-md-6 text-center">
                                <img src="../../../../assets/images/scan_code.svg" width="55px">
                            </div>
                        </div>
                    </li>
                    <li style="margin-top: 50px">
                        <div class="row mt-3 mb-3" style="width:70vw; align-items: center;">
                            <div class="col-md-6">
                                    <p>Tap your card to the phone to activate it.</p> 
                            </div>
                            <div class="col-md-6 text-center">
                                <img  src="../../../../assets/images/tap_card.svg" width="100px">
                            </div>
                        </div>
                    </li>
                    <li style="margin-top: 50px">
                        <div class="row mt-3 mb-3" style="width:70vw; align-items: center;">
                            <div class="col-md-6">
                                    <p>Click "Activate" to activate your profile.</p> 
                            </div>
                            <div class="col-md-6 text-center">
                                <img  src="../../../../assets/images/activate.svg" width="55px">
                            </div>
                        </div>
                    </li>
                    <li style="margin-top: 50px">
                        <div class="row mt-3 mb-3" style="width:70vw; align-items: center;">
                            <div class="col-md-6">
                                    <p>Create a profile to share your contact info on the go.</p> 
                            </div>
                            <div class="col-md-6 text-center">
                                <img  src="../../../../assets/images/profile.svg" width="55px">
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>